import Brand from "@/domain/Brand";
import axios from "axios";
import BackEndpoints from "@/router/endpoints/BackEndpoints";
import ToastService from "@/services/ToastService";
import ErrorUtils from "@/utils/ErrorUtils";

export default {
  async getDefaultBrand() {
    let brands = await this.list();
    let brand = brands.find((brand) => brand.name === "Disneyland CMP");

    if (!brand) {
      brand = brands[0];
    }

    return brand;
  },
  async list() {
    try {
      let response = await axios.get(BackEndpoints.brands);
      return response.data.map((node) => new Brand(node));
    } catch (error) {
      ToastService.error("Error when loading brands", ErrorUtils.getMessage(error));
      throw error;
    }
  },
};
